export default __webpack_public_path__ + "media/images/footer/poweredbyautoforce-4b558816b3e6f1511bf835ae81b84650.svg";